import { render, staticRenderFns } from "./TipComponent.vue?vue&type=template&id=5c2553f9&scoped=true&"
import script from "./TipComponent.vue?vue&type=script&lang=js&"
export * from "./TipComponent.vue?vue&type=script&lang=js&"
import style0 from "./TipComponent.vue?vue&type=style&index=0&id=5c2553f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2553f9",
  null
  
)

export default component.exports